import React from 'react'
import { ReactComponent as BannerSvg } from './assets/banner.svg'
import { Typography } from '~/components/typography'
import { useTranslation } from '@opus/web.core.hooks.use-translation'
import { Box, useTheme } from '@material-ui/core'
import { Button } from '~/components/button'
import { observer } from '~/common/mobx.decorator'
import { careCredentialStore } from '../care-credential/care-credential.store'

export const CareVerifyCredentialFeature = observer(() => {
	const { t } = useTranslation()
	const theme = useTheme()
	return (
		<Box
			style={{
				height: '100%',
				width: '100%',
				position: 'absolute',
				margin: 'auto',
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'center',
				justifyContent: 'center',
				gap: '32px',
			}}
		>
			<BannerSvg />

			<Typography style={{ color: theme.palette?.status?.success?.medium, fontSize: '24px', fontWeight: 'bold' }} align="center">
				{t('SUBMIT_JOTFORM')}
			</Typography>
			<Button
				fullWidth={false}
				onClick={(e) => {
					careCredentialStore.setSelectedCredential(null)
					careCredentialStore.fetchCredentials()
					//Trigger Custom Event From Iframe To Parent Document
					window.parent.postMessage('complete_and_close', '*')
					return window?.ReactNativeWebView?.postMessage('complete_and_close')
				}}
				style={{
					margin: '20px 0',
					maxWidth: 300,
				}}
			>
				{t('COMPLETE_AND_CLOSE')}
			</Button>
		</Box>
	)
})
